module.exports = __webpack_public_path__ + "img/become-provider.d23832c8.jpg";